module.exports = __webpack_public_path__ + "static/media/hot-cat-banner.ffd13a28.png";